import React from "react";
import "../Privacy_Policy/Privacy_Policy.css";

export default function Privacy_Policy() {
  const informationUsage = [
    "לצורך טיפול בפניות המתקבלות דרך האתר ובאמצעי הקשר המופיעים בו.",
    "לצורך יצירת קשר עם לקוחות ומתעניינים לקבלת פרטים, הצעת מחיר, תיאום שירות או המשך טיפול בפנייה.",
    "לצורך מתן שירותי הובלה, מנופים, הרמות, שינוע והובלת ציוד בהתאם לשירות שהתבקש.",
    "לצורך תפעול האתר, שיפור התוכן, השירותים וחוויית הגלישה.",
    "לצורך הפקת נתונים סטטיסטיים והבנת אופן השימוש באתר, במטרה לשפר את הפעילות והתוכן המוצגים בו.",
    "לצורך שמירת תיעוד של פניות, בקשות להצעות מחיר, תיאומי שירות ותקשורת עם לקוחות.",
    "לצורך משלוח עדכונים, הצעות או מידע שיווקי, ככל שהדבר מותר על פי דין ובהתאם להסכמות הנדרשות.",
    "לצורך עמידה בדרישות החוק, מניעת שימוש בלתי מורשה באתר והגנה על זכויותיה של החברה."
  ];

  const collectedInformation = [
    "שם פרטי ומשפחה, ככל שנמסר.",
    "מספר טלפון ופרטי קשר נוספים.",
    'כתובת דוא"ל, ככל שנמסרה.',
    "תוכן ופרטי הפנייה שהמשתמש בחר למסור באמצעות האתר.",
    "פרטים הנדרשים לצורך הכנת הצעת מחיר, תיאום הובלה או הזמנת שירות.",
    "מידע טכני וסטטיסטי הקשור לשימוש באתר, כגון סוג מכשיר, סוג דפדפן, כתובת IP, דפים שנצפו ונתוני שימוש.",
    "כל מידע נוסף שהמשתמש בוחר למסור לנו מרצונו."
  ];

  const informationUse = [
    "טיפול בפניות ומתן מענה ללקוחות, קבלנים, חברות ומתעניינים.",
    "יצירת קשר לצורך הצעת מחיר, תיאום הובלה, שירותי מנוף או המשך טיפול בפנייה.",
    "שיפור האתר, השירותים, התוכן וחוויית המשתמש.",
    "ניהול ושמירת תיעוד של פניות, הזמנות ושירותים שניתנו.",
    "שליחת מידע שיווקי או הצעות, כאשר הדבר מותר על פי דין ובהתאם להסכמות שניתנו.",
    "אבטחת האתר והמערכות, מניעת שימוש לרעה, איתור תקלות ושמירה על פעילות תקינה.",
    "עמידה בדרישות הדין והגנה על זכויותיה של ש.מ הובלות ומנופים."
  ];

  const renderList = (items) => {
    return items.map((text, index) => (
      <div
        key={index}
        style={{
          position: "relative",
          paddingRight: "20px",
          marginBottom: "12px"
        }}
      >
        <span
          style={{
            position: "absolute",
            right: "0",
            top: "0",
            fontSize: "16px",
            fontWeight: "bold"
          }}
        >
          •
        </span>

        <p style={{ margin: "0" }}>
          {text}
        </p>
      </div>
    ));
  };

  return (
    <div className="Privacy_Policy-page">

      <div className="Privacy_Policy-hero">
        <div className="Privacy_Policy-overlay">
          <h1>מדיניות פרטיות</h1>
        </div>

        <div></div>
      </div>

      {/* CONTENT */}
      <div className="page3">
        <div className="container">

          <h2 className="top-text">
            כללי
          </h2>

          <div className="content-row">

            <div className="text-box">
              <p>
                אנו באתר ש.מ הובלות ומנופים מכבדים את פרטיותם של
                משתמשי האתר ופועלים במטרה לשמור על המידע הנמסר לנו.
                מדיניות פרטיות זו מסבירה באופן כללי איזה מידע עשוי
                להיאסף במהלך השימוש באתר, כיצד נעשה בו שימוש ומהן
                המטרות שלשמן הוא עשוי להישמר.
              </p>

              <p>
                השימוש באתר ובשירותים המוצעים באמצעותו כפוף למדיניות
                פרטיות זו ולהוראות הדין הרלוונטיות. השימוש באתר מהווה
                הסכמה לתנאים המפורטים במדיניות זו, בכפוף לזכויות
                המשתמש על פי כל דין.
              </p>
            </div>

          </div>

          <h2 className="main-title">
            שינויים במדיניות הפרטיות
          </h2>

          <div className="bottom-text">
            <p>
              ש.מ הובלות ומנופים רשאית לעדכן את מדיניות הפרטיות מעת
              לעת בהתאם לשינויים בפעילות האתר, בשירותים הניתנים או
              בדרישות הדין. במקרה של שינוי מהותי באופן השימוש במידע
              אישי, ניתן לפרסם באתר הודעה מתאימה.
            </p>

            <p>
              הנוסח המעודכן של מדיניות הפרטיות יהיה הנוסח הקובע
              מרגע פרסומו באתר, אלא אם צוין אחרת.
            </p>
          </div>

          <h2 className="main-title">
            שימוש במידע
          </h2>

          <div className="bottom-text">

            <p>
              מידע שנמסר במסגרת השימוש באתר או במהלך יצירת קשר
              עשוי לשמש אותנו למטרות שונות הקשורות למתן השירות
              ולהפעלת האתר, ובין היתר:
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(informationUsage)}
            </div>

          </div>

          <h2 className="main-title">
            עוגיות
          </h2>

          <div className="bottom-text">

            <p>
              Cookie הוא קובץ מידע קטן אשר עשוי להישמר במחשב,
              בטלפון או במכשיר אחר של המשתמש. קובצי Cookies עשויים
              לסייע בתפעול האתר, שמירת העדפות, שיפור חוויית הגלישה
              ואיסוף מידע סטטיסטי בנוגע לשימוש באתר.
            </p>

            <p>
              האתר עשוי לעשות שימוש בכלים טכנולוגיים של מדידה,
              סטטיסטיקה וניתוח וכן בשירותים של ספקים חיצוניים.
              שירותים אלה עשויים להשתמש בקובצי Cookies בהתאם
              למדיניות הפרטיות ולתנאים שלהם.
            </p>

            <p>
              ניתן לנהל או לחסום קובצי Cookie באמצעות הגדרות
              הדפדפן. עם זאת, חסימת Cookies מסוימים עלולה לגרום
              לכך שחלק מהפונקציות באתר לא יפעלו באופן מלא.
            </p>

          </div>

          <h2 className="main-title">
            איזה מידע עשוי להיאסף
          </h2>

          <div className="bottom-text">

            <p>
              בהתאם לאופן שבו נעשה שימוש באתר ולמידע שהמשתמש בוחר
              למסור, עשויים להיאסף הפרטים הבאים:
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(collectedInformation)}
            </div>

          </div>

          <h2 className="main-title">
            כיצד אנו משתמשים במידע
          </h2>

          <div className="bottom-text">

            <p>
              המידע המתקבל באמצעות האתר עשוי לשמש לצורך טיפול
              בפניות, מתן שירות, הכנת הצעות מחיר, תיאום עבודות,
              שיפור פעילות האתר ושמירה על קשר עם לקוחות ומתעניינים.
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(informationUse)}
            </div>

          </div>

          <h2 className="main-title">
            אבטחת מידע
          </h2>

          <div className="bottom-text">
            <p>
              ש.מ הובלות ומנופים נוקטת באמצעים סבירים ומקובלים
              שנועדו לסייע בהגנה על המידע המצוי בשליטתה מפני
              גישה בלתי מורשית, שימוש לרעה, אובדן או שינוי.
            </p>

            <p>
              יחד עם זאת, אין אפשרות להבטיח באופן מוחלט כי מערכות
              מידע או העברת מידע באמצעות האינטרנט יהיו חסינות
              לחלוטין מפני חדירה, תקלה או גישה שאינה מורשית.
            </p>
          </div>

          <h2 className="main-title">
            פרסומות באתר
          </h2>

          <div className="bottom-text">
            <p>
              האתר עשוי להציג פרסומות, תכנים או שירותים של גורמים
              חיצוניים. גורמים אלה עשויים להשתמש בטכנולוגיות כגון
              Cookies או טכנולוגיות דומות לצורך מדידה, ניתוח,
              התאמת פרסום או הצגת תוכן, בהתאם למדיניות שלהם.
            </p>
          </div>

          <h2 className="main-title">
            מסירת מידע לצדדים שלישיים
          </h2>

          <div className="bottom-text">
            <p>
              ש.מ הובלות ומנופים אינה מוכרת או משכירה מידע אישי
              של משתמשי האתר לצדדים שלישיים לצורכי מסחר במידע.
              עם זאת, מידע עשוי להימסר לספקי שירות או לגורמים
              הפועלים מטעם החברה כאשר הדבר נדרש לצורך תפעול האתר,
              מתן שירות, תחזוקה, אבטחת מערכות, ניתוח נתונים או
              עמידה בדרישות החוק.
            </p>
          </div>

          <h2 className="main-title">
            חוק הגנת הפרטיות
          </h2>

          <div className="bottom-text">

            <p>
              מדיניות זו נועדה להסדיר את אופן הטיפול במידע בהתאם
              להוראות הדין הרלוונטיות, לרבות הוראות חוק הגנת
              הפרטיות, התשמ"א–1981, והתקנות מכוחו, ככל שהן חלות
              על פעילות האתר והחברה.
            </p>

            <p>
              במהלך השימוש באתר עשוי להיאסף מידע הקשור לאופן
              השימוש באתר, לשירותים שבהם המשתמש התעניין ולפרטים
              נוספים שהמשתמש בחר למסור. המשתמש אינו חייב למסור
              מידע אישי בכל מקרה, אולם במקרים מסוימים מסירת מידע
              עשויה להיות נחוצה לצורך יצירת קשר, קבלת הצעת מחיר,
              תיאום שירות או טיפול בפנייה.
            </p>

          </div>

          <h2 className="main-title">
            זכויות המשתמש
          </h2>

          <div className="bottom-text">

            <p>
              בכפוף להוראות הדין ולזכויות הקבועות בו, משתמש רשאי
              לפנות אלינו בנוגע למידע שנמסר על ידו ולבקש לעיין בו,
              לתקן מידע שאינו נכון או לעדכן פרטים שנמסרו.
            </p>

            <p>
              בקשות ושאלות בנוגע למידע אישי ניתן להפנות באמצעות
              פרטי הקשר המופיעים באתר.
            </p>

          </div>

          <h2 className="main-title">
            יצירת קשר
          </h2>

          <div className="bottom-text">

            <p>
              בכל שאלה הנוגעת למדיניות הפרטיות, לאופן הטיפול
              במידע או לנושאי פרטיות באתר, ניתן לפנות אל
              ש.מ הובלות ומנופים באמצעות פרטי הקשר המופיעים באתר.
            </p>

          </div>

        </div>
      </div>
    </div>
  );
}
